import './styles/styles.scss';
import 'core-js/es6/symbol';
import 'core-js/es6/promise';
import 'core-js/es6/array';
import 'core-js/es6/number';
import 'core-js/es6/object';
import configureStore from './store/configureStore';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import {http} from './features/shared/services';
import injectTapEventPlugin from 'react-tap-event-plugin';
import muiTheme from './styles/teamologyTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import {Provider} from 'react-redux';
import React from 'react';
import {render} from 'react-dom';
import routes from './routes';
import Spin from 'react-spin';
import {syncHistoryWithStore} from 'react-router-redux';
import toastr from 'toastr';
import {browserHistory, Router} from 'react-router';
import {MainContent, Page, PageBody} from './features/layout/components';

toastr.options.positionClass = 'toast-bottom-full-width';
toastr.options.timeOut = 5000;

const appElement = document.getElementById('app');

// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin();

function launchApplication() {
  const store = configureStore();
  const history = syncHistoryWithStore(browserHistory, store);

  render(
    <MuiThemeProvider muiTheme={getMuiTheme(muiTheme)}>
      <Provider store={store}>
        <Router history={history} routes={routes} />
      </Provider>
    </MuiThemeProvider>,
    appElement
  );
}

if (/^(.*;)?XSRF-TOKEN=[^;]+(.*)?$/.test(document.cookie)) {
  launchApplication();
} else {
  render(
    <MuiThemeProvider>
      <Page pageClassName="loading-page">
        <PageBody>
          <MainContent hideRainbow>
            <h1 style={{marginTop: '15px', paddingLeft: '15px'}}>Loading...<Spin config={{left: '235px', top: '23px'}} /></h1>
          </MainContent>
        </PageBody>
      </Page>
    </MuiThemeProvider>,
    appElement
  );
  http.get('anti_forgery_token')
    .then(() => launchApplication())
    .catch(error => {
      render(<h1 style={{marginTop: '15px', paddingLeft: '15px'}}>Application failed to load</h1>, appElement);
      throw error;
    });
}



// WEBPACK FOOTER //
// ./app/index.js